import classNames from 'classnames';
import { Image } from 'src/components/common/Image';
import styles from './GiftCard.module.scss';
export const GiftCard = ({
  title,
  subtitle,
  image,
  titleClassName
}: {
  title: string;
  subtitle: string;
  image: string;
  titleClassName?: string;
}) => <div className={styles.card} data-sentry-component="GiftCard" data-sentry-source-file="index.tsx">
    <Image src={image} alt="present-bow" width={70} height={86} className={styles.cardImage} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    <div>
      <h3 className={classNames(styles.cardTitle, titleClassName)}>{title}</h3>
      <p className={styles.cardSubtitle}>{subtitle}</p>
    </div>
  </div>;